import NotificationsService from '@/services/NotificationsService';
import { defineStore } from 'pinia';

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    models: [] as AppNotification[],
    navNotifications: [] as AppNotification[],
    unreadCount: 0,
  }),

  getters: {
    unreadNotifications: (state) => {
      return state.navNotifications.filter((notification) => !notification.read_at);
    },

    unreadCountComputed: (state) => {
      return state.navNotifications.filter((notification) => !notification.read_at).length;
    },
  },

  actions: {
    async fetchNotifications(form: ApiRequests['api.v1.notifications.index'] = {}): Promise<
      Paginator<AppNotification>
    > {
      const [data, error] = await NotificationsService.index(form);

      if(error) {
        throw error;
      }

      return data as Paginator<AppNotification>;
    },

    async markAllAsRead() {
      const [data, error] = await NotificationsService.markAllAsRead();

      if(error) {
        throw error;
      }

      // Update all notifications to be read
      this.models = this.models.map((notification) => ({
        ...notification,
        read_at: notification.read_at || new Date().toISOString(),
      }));

      return data;
    },

    async destroy(notificationId: string) {
      const [data, error] = await NotificationsService.destroy(notificationId);

      if(error) {
        throw error;
      }

      // Remove notification from models
      this.models = this.models.filter((notification) => notification.id !== notificationId);
      this.navNotifications = this.navNotifications.filter((notification) => notification.id !== notificationId);

      return data;
    },

    async destroyAll() {
      const [data, error] = await NotificationsService.destroyAll();

      if(error) {
        throw error;
      }

      // Clear all notifications
      this.models = [];
      this.navNotifications = [];
      this.unreadCount = 0;

      return data;
    },
  },
});
